import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '@app/shared/services/date.service';

@Pipe({
  name: 'toTime'
})
export class FilterToTime implements PipeTransform {

  transform(date: any): string {
    if (date.includes('am') || date.includes('pm')) {
      return date;
    }

    return DateService.toTimeFromDate(new Date(date));
  }
}
